<template>
  <div class="warp">
    <div class="warning" :class="warning.isAnimate ? 'animateWaring' : ''"  v-if="warning.status =='good' && warning.difficulty >= 80">
      <div class="catoon cool"></div>
      <p class="no-wrap">666，那么难的题目都做对啦！</p>
    </div>

    <div class="warning" :class="warning.isAnimate ? 'animateWaring' : ''"  v-else-if="warning.status =='hurry'">
      <div class="catoon hurry"></div>
      <p class="no-wrap">加快速度，你已经超过了建议时间了</p>
    </div>
    <div class="warning" :class="warning.isAnimate ? 'sadWaring' : ''" v-else-if="warning.status =='sad'">
      <div class="catoon sad"> </div>
      <p class="wrap">觉得有点难？可以点击我不会跳过，我们会为你调整难度挑选更适合你的题目。
        <el-row class="actionBtn">
          <el-col :span="24" class="continue" >
            <span @click="popGoOnAction">继续答题</span>
          </el-col>
          <el-col :span="9" :offset="7" class="jump" >
            <span @click="popJumpAction">我不会，跳过</span>
          </el-col>
        </el-row>
      </p>
    </div>
  </div>
</template>
<script>
import Bus from '@/utils/bus.js';
export default {
  name: "Warning",
  data() {
    return {};
  },
  props: {
    warning: {
      isAnimate: {
        type: Boolean,
        default: false
      },
      difficulty: 0,
      status: 'sad'
    },
  },
  mounted() {
    let _this = this;
    if(this.warning.isAnimate && this.warning.status !='sad'){
      setTimeout(()=>{
          _this.warning.isAnimate = false;
      },3000)
    }
    Bus.$on('warningShow',() =>{
      this.warning.isAnimate = false
    })
  },
  methods: {
    popGoOnAction(){
      this.$emit('popGoOnAction');
    },
    popJumpAction(){
      Bus.$emit('eventName') //（传递事件）
    }
  }
};
</script>
<style lang="scss" scoped>
  @import '@/assets/css/theme/register.scss';
.warning {
  position: fixed;
  right: 10px;
  bottom: 150px;
  z-index: 2001;
  /*width: 225px;*/
  opacity: 0;
  .catoon {
    width: 92px;
    height:89px;
    position: relative;
    z-index:100;
    &.cool{
      background: url('~@/assets/css/theme/#{$theme-name}/imgs/cool.png') no-repeat;
      background-size: 100% 100%;
    }
    &.hurry{
      background: url('~@/assets/css/theme/#{$theme-name}/imgs/hurry.png') no-repeat;
      background-size: 100% 100%;
    }
    &.sad{
      background: url('~@/assets/css/theme/#{$theme-name}/imgs/sad.png') no-repeat;
      background-size: 100% 100%;
    }
  }
  p {
    // position: absolute;
    // top: 80px;
    // right: 0;
    margin-top: -10px;
    padding: 12px;
    font-size: 14px;
    color: $theme-text-color-gray6;
    line-height: 20px;
    background: $theme-text-color-white;
    box-shadow: 0px 1px 6px 0px rgba(0, 0, 0, 0.14);
    border-radius: 10px;
    &.no-wrap{
       white-space: nowrap;
    }
    &.wrap{
      width:270px;
      text-align: left;
    }
    .actionBtn {
      margin-top: 8px;
      display: flex;
    }
    .continue {
      width:80px;
      height:24px;
      font-size: 16px;
      color: rgba(120, 153, 158, 1);
      line-height: 24px;
      cursor: pointer;
      text-align: center;
      &:hover{
        background:rgba(212,223,225,.2);
        border-radius:11px;
      }
    }
    .jump {
      font-size: 16px;
      color: #FDB550;
      line-height: 24px;
      cursor: pointer;
      flex: none;
      text-align: center;
    }
  }
}
.animateWaring {
  -webkit-animation: bounceInRight linear 1s forwards;
  opacity: 1;
}
.sadWaring {
    opacity: 1;
}
</style>





// WEBPACK FOOTER //
// src/components/Warning.vue